import React from 'react';
import {inject, observer} from 'mobx-react';
import {injectIntl} from 'react-intl';
import {Panel} from 'react-bootstrap';


@injectIntl @inject('analyticsStore') @observer
export default class FirstReplyStatistics extends React.Component{

    render(){
        const {intl, analyticsStore} = this.props;
        return(
            <Panel style={{height: '386px', overflow: 'auto'}}>
                <h3>{intl.formatMessage({id: 'time_to_first_reply_title' })}</h3>
                <br/> 
                <div className='text-center'>
                    <h2>{analyticsStore.averageFirstReply}</h2>
                    <div className='text-muted'>
                        {analyticsStore.averageFirstReplyInDays() ?  
                                         intl.formatMessage({id: 'average_first_reply_days'}) : 
                                         intl.formatMessage({id: 'average_first_reply_hours'})}
                    </div>
                    <br/>
                    <br/>
                </div>
            </Panel>
        );
    }
};